<script>
import Component from '~/sites/oknanebodvere/pages/articleList/_slug'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/clanky/:slug',
      en: '/articles/:slug',
      sk: '/clanky/:slug',
    },
  },
}
</script>
